import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasEngranaje.png';
import Img2 from '../../img/products/bombas/BombasEngranajes/BombaEngranaje1.png';
import Img3 from '../../img/products/bombas/BombasEngranajes/BombaEngranaje2.png';
import Img4 from '../../img/products/bombas/BombasEngranajes/BombaEngranaje3.png';

const BombasEngranaje = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Bombas de Engranaje Interno y Externo</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-6">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-6">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            <div className="col-6">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas de engranaje son un tipo de bomba de desplazamiento positivo que utilizan engranajes
             en malla para mover fluidos. Estas bombas son conocidas por su simplicidad, fiabilidad y 
             capacidad para manejar fluidos de alta viscosidad. Se utilizan ampliamente en aplicaciones 
             industriales, como en la transferencia de aceites, combustibles, productos químicos y fluidos hidráulicos.
          </p>
          <p className="lead text-justify">
            Los engranajes interdigitados giran en direcciones opuestas, creando cavidades que atrapan y mueven el 
            fluido desde la entrada hasta la salida y aseguran un flujo constante y controlado, independientemente 
            de las variaciones de presión en el sistema. 
          </p>
          <p className="lead text-justify">
            El diseño de desplazamiento positivo asegura un flujo constante y uniforme, ideal para aplicaciones 
            que requieren un manejo preciso del fluido.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BombasEngranaje;
